import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAdminStore } from './stores/adminStore';
import { AdminLayout } from './layouts/AdminLayout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Accounts } from './pages/Accounts';
import { AccountDetail } from './pages/AccountDetail';
import { Moderation } from './pages/Moderation';
import { AuditLog } from './pages/AuditLog';
import { Errors } from './pages/Errors';
import { RequestLogs } from './pages/RequestLogs';
import { DeviceExclusions } from './pages/DeviceExclusions';
import { Settings } from './pages/Settings';

function ProtectedRoute({ children, minRole }: { children: React.ReactNode; minRole?: string }) {
  const { token, role } = useAdminStore();

  if (!token || !role) {
    return <Navigate to="/login" replace />;
  }

  // Role hierarchy: super > mod > support
  const roleHierarchy = ['support', 'mod', 'super'];
  const userRoleIndex = roleHierarchy.indexOf(role);
  const minRoleIndex = minRole ? roleHierarchy.indexOf(minRole) : 0;

  if (userRoleIndex < minRoleIndex) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/accounts/:id" element={<AccountDetail />} />
          <Route
            path="/moderation"
            element={
              <ProtectedRoute minRole="mod">
                <Moderation />
              </ProtectedRoute>
            }
          />
          <Route path="/audit" element={<AuditLog />} />
          <Route
            path="/devices"
            element={
              <ProtectedRoute minRole="super">
                <DeviceExclusions />
              </ProtectedRoute>
            }
          />
          <Route path="/errors" element={<Errors />} />
          <Route path="/request-logs" element={<RequestLogs />} />
          <Route
            path="/settings"
            element={
              <ProtectedRoute minRole="super">
                <Settings />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
